var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlueidLogomarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "87px",
    viewBox: "0 0 51 87",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0.0-Branding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5061802,65.4194967 L43.19651,65.4194967 C47.2015335,65.4194967 50.4514509,62.1447921 50.4514509,58.112952 C50.4514509,54.0736524 47.2015335,50.8026776 43.19651,50.8026776 L14.5061802,50.8026776 L14.5061802,43.7087276 C14.5061802,27.6671509 27.3762972,14.6168191 43.19651,14.6168191 C47.2015335,14.6168191 50.4514509,11.3421146 50.4514509,7.31027443 C50.4514509,3.27470457 47.2015335,0 43.19651,0 C19.3773547,0 0,19.6072003 0,43.7087276 L0,83.9301559 C4.22341199,84.6686428 9.06867605,85.4668054 14.5061802,86.2686977 L14.5061802,65.4194967 Z",
    id: "Fill-2",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlueidLogomarkWhite);
export default __webpack_public_path__ + "static/media/flueid-logomark-white.626c469f5d63e6a99c12c540d1c430b4.svg";
export { ForwardRef as ReactComponent };